import 'css-chunk:../components/loading-indicator/index.module.scss';export default {
  "indicator": "_indicator_1f8za_1",
  "circle": "_circle_1f8za_11",
  "indicatorbounce": "_indicatorbounce_1f8za_1",
  "one": "_one_1f8za_24",
  "two": "_two_1f8za_28",
  "three": "_three_1f8za_32"
};